import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridRowProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  FINANCIAL_YEAR,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import {
  deleteSalesChallan,
  getAllSalesChallan,
} from "./services/salesChallan.services";
import {
  clearFilterSalesChallan,
  clearSalesChallanID,
  setFilterSalesChallan,
  setSalesChallanID,
} from "./salesChallanSlice";
import { clearItemList } from "../Item/itemSlice";
import { IoPrint } from "react-icons/io5";
import _debounce from "lodash/debounce";
import { TextBox } from "@progress/kendo-react-inputs";
import { filterClearIcon } from "@progress/kendo-svg-icons";
import { FaEye } from "react-icons/fa";

const SalesChallan: React.FC = () => {
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  const handleCreate = () => {
    navigate("/saleschallan/create");
  };

  return (
    <>
      <DeleteSalesChallanDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Sales Challan List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New"}
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <SalesChallanGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const SalesChallanGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditBtnRef = useRef<any>(false);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const FilterSalesChallan: any = useAppSelector(
    (state) => state.salesChallan.FilterSalesChallan
  );

  const SalesChallanList = useAppSelector(
    (state) => state.salesChallan.SalesChallanList
  );
  const loading = useAppSelector((state) => state.salesChallan.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    return () => {
      dispatch(clearItemList());
      dispatch(setCurrentPage(0));

      if (!isEditBtnRef.current) {
        dispatch(clearFilterSalesChallan());
      }
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterSalesChallan,
      financial_year: FINANCIAL_YEAR,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllSalesChallan(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEdit = (sales_challan_guid: any) => {
      navigate("/saleschallan/edit", {
        state: { sales_challan_guid: sales_challan_guid },
      });
    };

    const handleOpenDeleteDialog = (sales_challan_guid: any) => {
      dispatch(openDialog("deleteSalesChallan"));
      dispatch(setSalesChallanID(sales_challan_guid));
    };

    const handlePrint = (sales_challan_guid: any) => {
      window.open(`/saleschallanprint/${sales_challan_guid}?print=1`);
    };

    const handleView = (sales_challan_guid: any) => {
      window.open(`/saleschallanprint/${sales_challan_guid}`);
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            ref={isEditBtnRef}
            onClick={() => {
              isEditBtnRef.current = true;
              handleEdit(props.dataItem?.sales_challan_guid);
            }}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem?.sales_challan_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="View"
          onClick={() => handleView(props.dataItem?.sales_challan_guid)}
        >
          <FaEye className="absolute-position" style={{ fontSize: "20px" }} />
        </IconButton>
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Print"
            onClick={() => handlePrint(props.dataItem?.sales_challan_guid)}
          >
            <IoPrint
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const rowRender = (
    trElement: React.ReactElement<HTMLTableRowElement>,
    props: GridRowProps
  ) => {
    const isdelivered = props.dataItem.ispendingchallan ;
    const deliver = { backgroundColor: "#ffdada" };
    const notDelivered = { backgroundColor: "transparent" };
    const trProps: any = { style: isdelivered ? notDelivered : deliver };
    let childrenArray: React.ReactNode[] = [];

    if (trElement.props.children) {
      if (trElement.props.children instanceof HTMLCollection) {
        childrenArray = Array.from(trElement.props.children).map(
          (child: any) => {
            return React.isValidElement(child) ? child : <>{child}</>;
          }
        );
      } else {
        childrenArray = [trElement.props.children];
      }
    }

    return React.cloneElement(trElement, { ...trProps }, childrenArray);
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        rowRender={rowRender}
        style={{ maxHeight: "calc(100vh - 152px)" }}
        className="responsive-table"
        filterable={true}
        filter={filter}
        data={filter ? filterBy(SalesChallanList, filter) : SalesChallanList}
        onFilterChange={handleFilterChange}
        total={SalesChallanList[0]?.itemcount || SalesChallanList?.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="challan_no_string"
          title="Challan No"
          cell={(props: any) => (
            <td>
              <div
                className={isEditAccess ? "hoverableName" : "normalName"}
                onClick={() =>
                  isEditAccess &&
                  navigate("/saleschallan/edit", {
                    state: {
                      sales_challan_guid: props.dataItem?.sales_challan_guid,
                    },
                  })
                }
              >
                {props.dataItem?.challan_no_string}
              </div>
            </td>
          )}
        />
        <Column field="challan_date" title="Challan Date" />
        <Column
          field="account_name"
          title="Account Name"
          filterCell={CommonFilterCell}
        />
        <Column
          field="total_amount"
          title="Total"
          cell={(props: any) => (
            <td className="text-end">
              {props.dataItem.total_amount
                ? formatIndianNumber(props.dataItem?.total_amount)
                : null}
            </td>
          )}
        />
        {(isEditAccess || isDeleteAccess || isPrintAccess) && (
          <Column
            field="id"
            title="Actions"
            cell={MyEditCommandCell}
            width={"170px"}
            filterable={false}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteSalesChallanDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const SalesChallanID = useAppSelector(
    (state) => state.salesChallan.SalesChallanID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSalesChallan = useAppSelector(
    (state) => state.salesChallan.FilterSalesChallan
  );

  const handleDeleteAction = async (ID: any) => {
    if (ID) {
      const response = await dispatch(deleteSalesChallan(ID));
      dispatch(setCurrentPage(0));
      const payload = {
        ...FilterSalesChallan,
        financial_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllSalesChallan(payload));
        dispatch(closeDialog());
        dispatch(clearSalesChallanID());
      } else {
        dispatch(getAllSalesChallan(payload));
        dispatch(closeDialog());
        dispatch(clearSalesChallanID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteSalesChallan" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Sales Challan "}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Sales Challan ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(SalesChallanID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const CommonFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSalesChallan: any = useAppSelector(
    (state) => state.salesChallan.FilterSalesChallan
  );
  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      dispatch(setCurrentPage(0));
      const payload = {
        ...updatedFilters,
        financial_account_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: 0 * +pageLimit,
      };

      dispatch(getAllSalesChallan(payload));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = {
        ...FilterSalesChallan,
        [inputField]: inputValue,
      };
      dispatch(setFilterSalesChallan(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FilterSalesChallan, [props.field]: "" };
    dispatch(setFilterSalesChallan(updatedFilters));

    const payload = {
      ...updatedFilters,
      financial_account_year: FINANCIAL_YEAR,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };

    dispatch(getAllSalesChallan(payload));
  };

  return (
    <div className="d-flex">
      <TextBox
        value={FilterSalesChallan[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FilterSalesChallan[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

export default SalesChallan;
